import { render, staticRenderFns } from "./NewsletterLog.vue?vue&type=template&id=509d5352"
import script from "./NewsletterLog.vue?vue&type=script&lang=js"
export * from "./NewsletterLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports